import { useState } from "react";
import { Stepper, Step, StepLabel, Button, CircularProgress, Box } from "@mui/material";
import { Formik, Form } from "formik";
import MainCard from "../../styles/ui-component/cards/MainCard";
import initialBranchValuesForm from "./FormModel/initialBranchValues";
import useStyles from "./../../styles/styles";
import validationSchema from "./FormModel/validationSchema";
import { configState } from "../../recoil/atoms";
import { useRecoilValue } from "recoil";
import BranchAddress from "./Forms/BranchAddress";
import BranchContact from "./Forms/BranchContact";
import { AddBranchRequest, BranchApi } from "../../api/clinic-management";
import BranchCalendar from "./Forms/BranchCalendar";
import BranchServices from "./Forms/BranchServices";
import useAuthorization from "../Authentication/permissions/Authorization";
import { toast } from "react-toastify";

const steps = ["Address", "Calendar", "Contact", "Services"];

export default function BranchPage() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState<number>(0);
  const config = useRecoilValue(configState);
  const { canAddTenantBranch } = useAuthorization();
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <BranchAddress />;
      case 1:
        return <BranchCalendar />;
      case 2:
        return <BranchContact />;
      case 3:
        return <BranchServices />;
      default:
        return <div>Not Found</div>;
    }
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => setActiveStep(activeStep - 1);

  const addBranch = (values: AddBranchRequest, actions: any) => {
    const branch = new BranchApi(config);
    branch
      .addBranchToTenant(values)
      .then((res) => {
        toast.success(res?.data?.Message!);
        handleNext();
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const submitForm = (values: AddBranchRequest, actions: any) => {
    actions.setSubmitting(false);
    addBranch(values, actions);
  };

  const handleSubmit = (values: any, actions: any) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      handleNext();
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Box>
        <MainCard>
          {canAddTenantBranch && (
            <>
              <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Formik
                initialValues={initialBranchValuesForm}
                enableReinitialize={true}
                validationSchema={currentValidationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    {renderStepContent(activeStep)}

                    <div className={classes.buttons}>
                      {activeStep !== 0 && (
                        <Button onClick={handleBack} className={classes.button}>
                          Back
                        </Button>
                      )}
                      <div className={classes.wrapper}>
                        <Button
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          {isLastStep ? "Add Branch" : "Next"}
                        </Button>
                        {isSubmitting && <CircularProgress size={24} className={classes.buttonProgress} />}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </MainCard>
      </Box>
    </>
  );
}
